import React from 'react';
import { Input } from '../../Input';
import { Form } from 'antd';
import { FormItem } from '../../FormItem';
import { FontAwesomeIcon } from '../../FontAwesomeIcon';
import { faSearch } from '@fortawesome/pro-regular-svg-icons';

export type BlogSearchFormProps = {
    searchTerm?: string;
    onSearch: (searchTerm: string) => void;
    autoFocus?: boolean;
};

export const BlogSearchForm = ({
    searchTerm,
    onSearch,
    autoFocus,
}: BlogSearchFormProps) => {
    return (
        <Form
            onFinish={e => {
                return onSearch(e.searchTerm);
            }}
            style={{ width: '100%' }}>
            <FormItem name="searchTerm">
                <Input
                    autoFocus={autoFocus}
                    size="large"
                    placeholder="Procurar"
                    value={searchTerm}
                    prefix={<FontAwesomeIcon icon={faSearch} />}
                />
            </FormItem>
        </Form>
    );
};
